import { Container, createTheme, ThemeProvider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { div } from '../common';
import { Flex } from '../flex';
export var theme = createTheme({
    typography: {
        fontFamily: 'Montserrat',
        fontSize: 10
    },
    palette: {
        primary: {
            main: '#01C38D',
        },
        secondary: {
            main: "#FFF"
        }
    },
    props: {
        // Name of the component ⚛️
        MuiButtonBase: {
        // The properties to apply
        //disableRipple: true, // No more ripple, on the whole application 💣!
        },
    },
    overrides: {
        MuiTab: {
            root: {
                '&:focus': {
                    outline: 'none',
                },
                fontSize: 12,
                minHeight: 0,
                '&$selected': {
                    outline: 'none'
                }
            }
        },
        MuiTabs: {
            root: {
                minHeight: 0,
            }
        },
        MuiPaper: {
            elevation4: {
                boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.1)'
            },
            elevation1: {
                boxShadow: '2px 0px 3px 0px rgba(0,0,0,0.04)'
            }
        },
        MuiButton: {},
        MuiIconButton: {
            root: {
                '&:focus': {
                    outline: 'none',
                },
                marginLeft: 2,
                marginRight: 2,
            },
        },
        MuiAccordionSummary: {
            root: {
                userSelect: 'text',
                alignItems: 'center',
                minHeight: '40px !important',
                '&$expanded': {
                    margin: 0
                }
            },
            content: {
                margin: '8px 0',
                alignItems: 'center',
                '&$expanded': {
                    margin: 0
                }
            }
        },
        MuiLink: {
            root: {
                color: '#1084D3 !important',
                fontFamily: 'Montserrat',
                fontSize: 14,
                fontWeight: 500,
            }
        }
    }
});
/**
 * Top level page layout. All props are optional.
 */
export var PageLayout = function (_a) {
    var menu = _a.menu, maxWidth = _a.maxWidth, _b = _a.menuWidth, menuWidth = _b === void 0 ? 225 : _b, header = _a.header, footer = _a.footer, subheader = _a.subheader, children = _a.children, userClasses = _a.classes;
    var classes = PageLayout.useStyles({ classes: userClasses, menu: menu, menuWidth: menuWidth, subheader: subheader });
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement("div", { className: classes.root },
            header &&
                React.createElement("div", { className: classes.header },
                    typeof subheader === 'number' ? React.createElement("div", { className: classes.subheader }) : undefined,
                    header),
            subheader && typeof subheader !== 'number' ?
                React.createElement("div", { className: classes.subheader }, subheader)
                : undefined,
            React.createElement("div", { className: classes.viewport },
                menu &&
                    React.createElement("div", { className: classes.menu }, menu),
                React.createElement("div", { className: classes.children },
                    React.createElement(Container, { maxWidth: maxWidth }, children))),
            footer &&
                React.createElement("div", null, footer))));
};
export var PageContainer = function (props) {
    var classes = usePageContainerStyles(props), children = props.children, header = props.header, offset = props.offset;
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement("div", { className: classes.root },
            props.menu ?
                React.createElement(PageContainerMenu, null, props.menu)
                : null,
            React.createElement(Flex, { column: true, grow: true },
                header ?
                    React.createElement("div", { className: classes.header },
                        offset ? React.createElement("div", { className: classes.subheader }) : undefined,
                        header)
                    : null,
                children))));
};
var PageContainerMenu = div({
    backgroundColor: '#052C4C',
    width: 200,
    //    position: 'absolute',
    //    top: 0,
    //    left: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
});
export var Page = function (props) {
    var classes = usePageStyles(props), left = props.left, top = props.top, header = props.header, children = props.children, bottom = props.bottom, maxWidth = props.maxWidth;
    return React.createElement(React.Fragment, null,
        top ?
            React.createElement("div", { className: classes.subheader }, top)
            : undefined,
        React.createElement("div", { className: classes.viewport },
            left &&
                React.createElement("div", { className: classes.menu }, left),
            React.createElement("div", { className: classes.children },
                React.createElement(Container, { maxWidth: maxWidth },
                    header ?
                        React.createElement("div", { className: classes.header }, header)
                        : null,
                    children))),
        bottom &&
            React.createElement("div", null, bottom));
};
var usePageContainerStyles = makeStyles({
    root: {
        backgroundColor: '#EFF2F4',
        display: "flex",
        flexDirection: "row",
        margin: 0,
        height: "100%",
        width: '100%',
        position: 'relative',
        '& .MuiContainer-maxWidthXl': {
            maxWidth: 1400
        },
        '& .MuiContainer-root': {
            height: '100%'
        }
    },
    header: {
        color: 'white',
        padding: 10,
        zIndex: 1,
        position: 'relative',
        backgroundColor: '#052C4C',
    },
    subheader: {
        position: 'absolute',
        bottom: 0,
        marginLeft: -10,
        zIndex: -1,
        backgroundColor: '#EFF2F4',
        height: function (_a) {
            var offset = _a.offset;
            return -offset;
        },
        width: '100%'
    }
});
var usePageStyles = makeStyles({
    subheader: {
        zIndex: 1
    },
    menu: function (_a) {
        var menuWidth = _a.menuWidth;
        return ({
            width: menuWidth,
            padding: 8,
            display: 'flex',
            flexDirection: 'column',
        });
    },
    header: {
        width: '100%',
        left: function (props) { return props.menu ? props.menuWidth : 0; },
    },
    viewport: {
        flex: '1 1 auto',
        position: 'relative',
        flexFlow: 'row',
        display: 'flex',
        minHeight: 200,
    },
    children: {
        flex: '1 1 auto',
        padding: 8,
        bottom: 0,
        top: 0,
        left: function (props) { return props.left ? props.menuWidth : 0; },
        right: 0,
        position: 'absolute',
        overflowY: 'auto',
    }
});
PageLayout.useStyles = makeStyles({
    root: {
        backgroundColor: '#EFF2F4',
        display: "flex",
        flexFlow: "column",
        height: "100%",
        position: 'relative',
        '& .MuiContainer-maxWidthXl': {
            maxWidth: 1400
        },
        '& .MuiContainer-root': {
            height: '100%'
        }
    },
    header: {
        color: 'white',
        padding: 10,
        zIndex: 1,
        position: 'relative',
        backgroundColor: '#052C4C',
    },
    subheader: function (_a) {
        var subheader = _a.subheader;
        return typeof subheader === 'number' ?
            {
                position: 'absolute',
                bottom: 0,
                marginLeft: -10,
                zIndex: -1,
                backgroundColor: '#EFF2F4',
                height: -subheader,
                width: '100%'
            } : {};
    },
    menu: function (_a) {
        var menuWidth = _a.menuWidth;
        return ({
            width: menuWidth,
            padding: 8
        });
    },
    viewport: {
        flex: '1 1 auto',
        position: 'relative',
        flexFlow: 'row',
        display: 'flex',
        minHeight: 200,
    },
    children: function (props) { return ({
        flex: '1 1 auto',
        padding: 8,
        bottom: 0,
        top: 0,
        left: props.menu ? props.menuWidth : 0,
        right: 0,
        position: 'absolute',
        overflowY: 'auto',
    }); }
});
//# sourceMappingURL=PageLayout.js.map